import * as React from 'react';

import { useApplicationContext } from '../../../../../../../shared/utils/applicationContext';
import { SuperAgentLevelView } from '../../../../components/SuperAgentLevelView';
import { useOfferContext } from '../../../../context';
import { getQualityLevelSystemName } from '../AgentWorkHonestlyProofsContainer/utils';

export const SuperAgentLevelViewContainer: React.FC = () => {
  const offerData = useOfferContext();
  const levelSystemName = getQualityLevelSystemName(offerData);
  const { config } = useApplicationContext();
  const list = config.get<string>('moderation.QualityLevelTooltip') || '';
  const tooltip = list.split(',');

  if (!levelSystemName || levelSystemName !== 'max') {
    return null;
  }

  return <SuperAgentLevelView tooltip={tooltip} />;
};
